import React, { Component } from "react";
import { Divider, Row, Layout, Button } from "antd";
import { Link } from "react-router-dom";
import ReactGA from "react-ga4";
import HorizontalAdPopup from "../../ads/HorizontalAdPopup";
import HorizontalAdComponent from "../../ads/HorizontalAdComponent";
import InPageAdComponent from "../../ads/InPageAdComponent";
import throttle from "lodash.throttle";
import PropTypes from "prop-types";
import BestCatsTable from "../../table/BestCatsTable";
import TierListTable from "../../table/TierListTable";
import {
  FacebookShareButton,
  RedditShareButton,
  TwitterShareButton,
  VKShareButton,
  FacebookIcon,
  RedditIcon,
  TwitterIcon,
  VKIcon,
} from "react-share";
import VenatusAd from "../../ads/VenatusAd";
import VenatusAdWithPlaceholder from "../../ads/VenatusAdWithPlaceholder";
import {
  VENATUS_DESKTOP_LEADERBOARD,
  VENATUS_MOBILE_LEADERBOARD,
  VENATUS_MOBILE_INCONTENT,
  VENATUS_RICH_MEDIA_WITH_STICKY_VERTICAL,
  VENATUS_RICH_MEDIA,
} from "../../utilities/constants";

const shareURL = "https://mygamatoto.com/lugas-tier-list";
const { Content } = Layout;

export const initGA = () => {
  ReactGA.initialize(
    "G-MX6GYDK28N"
    // , {
    //   gaAddress: "https://onestoppress.com/analytics.js"
    // }
  );
};

export const logPageView = () => {
  ReactGA.set({ page: window.location.pathname + window.location.search });
};

class Lugas extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewportWidth: 0,
      compareCatsLevels: 30,
    };
  }
  componentDidMount() {
    this.saveViewportDimensions();
    window.addEventListener("resize", this.saveViewportDimensions);

    // initGA();
    // logPageView();

    document.title = "Lugas Tier List | Battle Cats Wiki for Cat Stats";
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.saveViewportDimensions);
  }

  saveViewportDimensions = throttle(() => {
    let adjustViewport;
    if (window.innerWidth < 636) {
      adjustViewport = 22;
    } else if (window.innerWidth < 948) {
      adjustViewport = 34;
    } else {
      adjustViewport = 46;
    }

    this.setState({
      viewportWidth: window.innerWidth - adjustViewport,
    });
  }, this.props.applyViewportChange);

  showModal = () => {
    this.setState({ isModalVisible: true });
  };

  handleCancel = () => {
    this.setState({ isModalVisible: false });
  };

  render() {
    const bestCats = [
      {
        key: "171-3",
        name: "Lufalan Pasalan",
        number: "171-3",
        form: "True",
        rarity: "Uber Super Rare",
        level: 1,
        health: 3000,
        damage: 18250,
        range: 720,
        kb: 1,
        speed: 4,
        dps: 2245,
        target: "Single",
        tba: "8.13",
        anim: "3.50",
        spawn: "324.53",
        cost: 4500,
        ability:
          "u1General Abilitiesu2: b1Criticalb2 (20% chance of a critical hit)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "241-3",
        name: "Shishilan Pasalan",
        number: "241-3",
        form: "True",
        rarity: "Uber Super Rare",
        level: 1,
        health: 7500,
        damage: 7500,
        range: 445,
        kb: 100,
        speed: 4,
        dps: 440,
        target: "Area",
        tba: "17.00",
        anim: "3.50",
        spawn: "157.87",
        cost: 4500,
        ability:
          "u1General Abilitiesu2: b1Strengthenb2 (attack power increases by 200% at 99% health) b1Surviveb2 (100% chance to survive a lethal strike)\nu1Not affected byu2: b1Waveb2",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "172-3",
        name: "Piccolan Pasalan",
        number: "172-3",
        form: "True",
        rarity: "Uber Super Rare",
        level: 1,
        health: 3000,
        damage: 28,
        range: 940,
        kb: 1,
        speed: 4,
        dps: 2,
        target: "Area",
        tba: "16.43",
        anim: "3.13",
        spawn: "324.53",
        cost: 4500,
        ability:
          "u1Against allu2: b1Weakenb2 (100% chance to weaken by 50% for 6.0s) b1Freezeb2 (100% chance to freeze for 3.0s)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "169-3",
        name: "Assassinlan Pasalan",
        number: "169-3",
        form: "True",
        rarity: "Uber Super Rare",
        level: 1,
        health: 2750,
        damage: 832,
        range: 1250,
        kb: 1,
        speed: 4,
        dps: 68,
        target: "Area",
        tba: "12.33",
        anim: "5.03",
        spawn: "324.53",
        cost: 4500,
        ability: "u1Against allu2: b1Slowb2 (100% chance to slow for 3.0s)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "170-3",
        name: "E. Kubilan Pasalan",
        number: "170-3",
        form: "True",
        rarity: "Uber Super Rare",
        level: 1,
        health: 3000,
        damage: 125,
        range: 450,
        kb: 1,
        speed: 4,
        dps: 10,
        target: "Single",
        tba: "12.80",
        anim: "3.50",
        spawn: "324.53",
        cost: 4500,
        ability:
          "u1General Abilitiesu2: b1Criticalb2 (100% chance of a critical hit) b1Wave attackb2 (100% chance to perform a Lv.8 Shockwave attack (Range: 1732))",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "462-2",
        name: "Legelan Pasalan",
        number: "462-2",
        form: "Evolved",
        rarity: "Legendary Rare",
        level: 1,
        health: 7500,
        damage: 6250,
        range: 300,
        kb: 5,
        speed: 20,
        dps: 1785,
        target: "Area",
        tba: "3.50",
        anim: "0.17",
        spawn: "124.53",
        cost: 4500,
        ability:
          " b1Omni Strikeb2 (Effective range -700~300)\nu1Not affected byu2: b1Weakenb2, b1Freezeb2, b1Slowb2, b1Knockbackb2, b1Warpb2, b1Waveb2",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "035-3",
        name: "Ultralan Pasalan",
        number: "035-3",
        form: "True",
        rarity: "Uber Super Rare",
        level: 1,
        health: 3000,
        damage: 5000,
        range: 650,
        kb: 1,
        speed: 4,
        dps: 265,
        target: "Area",
        tba: "18.93",
        anim: "2.97",
        spawn: "324.53",
        cost: 4500,
        ability:
          "u1Against white, red, black, floating, angel, alien, zombie, relic, akuu2: b1Freezeb2 (100% chance to freeze for 2.0s) b1Knockbackb2 (100% chance of knockback)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "565-3",
        name: "Fabulous Pasalan",
        number: "565-3",
        form: "True",
        rarity: "Uber Super Rare",
        level: 1,
        health: 3000,
        damage: 2500,
        range: 650,
        kb: 1,
        speed: 4,
        dps: 132,
        target: "Area",
        tba: "18.93",
        anim: "2.97",
        spawn: "324.53",
        cost: 4500,
        ability:
          "b1Surge Attacksb2 (100% chance to perform Surge Attacks for 3.33s (Range: -50~2950))",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "437-3",
        name: "Mystican Pasalan",
        number: "437-3",
        form: "True",
        rarity: "Uber Super Rare",
        level: 1,
        health: 4500,
        damage: 6000,
        range: 500,
        kb: 1,
        speed: 4,
        dps: 420,
        target: "Area",
        tba: "14.30",
        anim: "5.27",
        spawn: "191.20",
        cost: 2250,
        ability:
          "u1General Abilitiesu2: b1Long Distanceb2 (Effective range 400~1000) b1Multi-hit attackb2 (Attacks twice consecutively)\r\nu1Not affected byu2: b1Weakenb2, b1Freezeb2, b1Slowb2, b1Knockbackb2, b1Curseb2, b1Warpb2, b1Waveb2",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "547-3",
        name: "Sukelan Kakulan",
        number: "547-3",
        form: "True",
        rarity: "Uber Super Rare",
        level: 1,
        health: 4500,
        damage: 9000,
        range: 475,
        kb: 1,
        speed: 4,
        dps: 718,
        target: "Area",
        tba: "12.53",
        anim: "5.70",
        spawn: "224.53",
        cost: 4500,
        ability:
          "u1Against white, red, black, floating, angel, alien, zombie, relic, akuu2: b1Curseb2 (100% chance to curse for 4.0s)\nu1General Abilitiesu2: b1Multi-hit attackb2 (Attacks thrice consecutively)\nu1Not affected byu2: b1Curseb2 b1Surgeb2",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "626-2",
        name: "Furilan Pasalan",
        number: "626-2",
        form: "Evolved",
        rarity: "Uber Super Rare",
        level: 1,
        health: 3000,
        damage: 3000,
        range: 700,
        kb: 1,
        speed: 4,
        dps: 165,
        target: "Area",
        tba: "18.23",
        anim: "0.93",
        spawn: "324.53",
        cost: 4500,
        ability:
          "u1General Abilitiesu2: b1Barrier Breakerb2 (100% chance of breaking enemy barriers) b1Shield Piercingb2 (100% chance to break Aku shields)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
    ];

    const tierList = [
      {
        tier: "SS",
        cats: [],
      },
      {
        tier: "S",
        cats: [],
      },
      {
        tier: "A+",
        cats: [],
      },
      {
        tier: "A",
        cats: [{ name: "Lufalan Pasalan", number: "171-3" }],
      },
      {
        tier: "B+",
        cats: [{ name: "Shishilan Pasalan", number: "241-3" }],
      },
      {
        tier: "B",
        cats: [],
      },
      {
        tier: "B-",
        cats: [{ name: "Piccolan Pasalan", number: "172-3" }],
      },
      {
        tier: "C+",
        cats: [
          { name: "Assassinlan Pasalan", number: "169-3" },
          { name: "E. Kubilan Pasalan", number: "170-3" },
          { name: "Legelan Pasalan", number: "462-2" },
        ],
      },
      {
        tier: "C",
        cats: [],
      },
      {
        tier: "D",
        cats: [
          { name: "Ultralan Pasalan", number: "035-3" },
          { name: "Fabulous Pasalan", number: "565-3" },
          {
            name: "Mystican Pasalan",
            number: "437-3",
          },
          { name: "Sukelan Kakulan", number: "547-3" },
          {
            name: "Furilan Pasalan",
            number: "626-2",
          },
        ],
      },
    ];

    // console.log(typeof(bestCats))

    return (
      <div>
        <div className="pagetitle">
          <h1 style={{ padding: "10px 0 0 0", marginBottom: "6px" }}>
            Tier List
          </h1>
          <Divider style={{ margin: "0 0 0 0", padding: "0 0 0 0" }} />
        </div>
        <Layout style={{ padding: "0 12px 0 12px", background: "white" }}>
          <Content className="flexible-width">
            <Row style={{ padding: "16px 0 0 0" }}>
              <div>
                {/* {this.state.viewportWidth > 1024 ? (
                  <VenatusAdWithPlaceholder
                    placementId={VENATUS_DESKTOP_LEADERBOARD}
                  />
                ) : (
                  ""
                  // <VenatusAdWithPlaceholder
                  //   placementId={VENATUS_MOBILE_LEADERBOARD}
                  // />
                )} */}
                <h2 style={{ marginTop: "12px", fontSize: "24px" }}>
                  Lugas Tier List
                </h2>
                <p></p>
                <div>
                  Tier list for Tales of the Nekoluga, listed from worst to
                  best. Credit goes to the Tier List on the{" "}
                  <a href="https://www.reddit.com/r/battlecats/wiki/index">
                    Reddit r/battlecats Wiki
                  </a>
                  &nbsp;under the Cat Guides.
                  <p></p>
                  <i>Last updated: 31 January 2023</i>
                </div>
              </div>
            </Row>

            <Row style={{ margin: "16px 0 0 0" }}>
              <FacebookShareButton
                url={"http://mygamatoto.com" + window.location.pathname}
                style={{ marginRight: "0.25rem" }}
              >
                <FacebookIcon size={32} round />
              </FacebookShareButton>
              <TwitterShareButton
                url={"http://mygamatoto.com" + window.location.pathname}
                title="MyGamatoto - Lugas Tier List"
                style={{ marginRight: "0.25rem" }}
              >
                <TwitterIcon size={32} round />
              </TwitterShareButton>
              <RedditShareButton
                url={"http://mygamatoto.com" + window.location.pathname}
                style={{ marginRight: "0.25rem" }}
              >
                <RedditIcon size={32} round />
              </RedditShareButton>
              <VKShareButton
                url={"http://mygamatoto.com" + window.location.pathname}
                title="MyGamatoto - Lugas Tier List"
                style={{ marginRight: "0.25rem" }}
              >
                <VKIcon size={32} round />
              </VKShareButton>
            </Row>
            {this.state.viewportWidth > 1024 ? (
              ""
            ) : (
              <div style={{ margin: "10px 0 0 0" }}>
                <div
                  class="vm-placement"
                  id="vm-av"
                  data-format="isvideo"
                ></div>
              </div>
            )}
            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  11.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[10].number +
                      ".png"
                    }
                    alt={bestCats[10].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[10].number.slice(0, 3) +
                          "/" +
                          bestCats[10].name
                        }
                      >
                        {bestCats[10].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>
                  Not sure if this is a Cat... There's just something about
                  those burning locks of hair…
                  <p></p>
                  <b>Other forms: </b>Furiluga
                  <p></p>
                  <b>Pros: </b>Seemingly useful against Aku enemies due to its
                  Shield-piercing abilities, but its lack of immunity to Surge
                  attacks (common in Aku stages with enemies such as{" "}
                  <Link to={"/enemyinfo/555/Condemned%20Peng"}>
                    Condemned Peng
                  </Link>
                  ) and its long time between attacks makes it next to useless
                  in these stages.
                  <p></p>
                  <b>Cons: </b>Poor stats across the board. Consider replacing
                  him with the Breakerblast Cannon, and other shield piercers
                  like the{" "}
                  <Link to={"/catinfo/622/Aku%20Researcher"}>
                    Aku researcher
                  </Link>
                  .
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Furilan Pasalan"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <InPageAdComponent
              style={{ marginTop: "8px" }}
              dataAdClient="ca-pub-1920730948516638"
              dataAdSlot="8579060881"
            />
            {/* <div id="waldo-tag-14680"></div> */}
            <div style={{ paddingTop: "1em" }} />
            {/* {this.state.viewportWidth > 1024 ? (
              <span>
                <VenatusAdWithPlaceholder
                  placementId={VENATUS_DESKTOP_LEADERBOARD}
                />
              </span>
            ) : (
              <VenatusAdWithPlaceholder
                placementId={VENATUS_MOBILE_INCONTENT}
              />
            )} */}
            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  10.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[9].number +
                      ".png"
                    }
                    alt={bestCats[9].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[9].number.slice(0, 3) +
                          "/" +
                          bestCats[9].name
                        }
                      >
                        {bestCats[9].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>
                  Not sure if this is a Cat... There's just something about that
                  toothless smile…
                  <p></p>
                  <b>Other forms: </b>Papaluga, Papalan Pasalan
                  <p></p>
                  <b>Pros: </b>Its only mediocre strength is its Curse ability,
                  but even that is neutralised by its awful survivability.
                  <p></p>
                  <b>Cons: </b>His immunity to Surge may instead be its
                  downfall, as the cats that are meant to protect him will die
                  to it while he continues inching forward. The Curse ability is
                  also useless in most stages, and is only effective for a third
                  of his time between attack, leaving him vulnerable for the
                  remaining time.
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Sukelan Kakulan"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  9.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[8].number +
                      ".png"
                    }
                    alt={bestCats[8].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[8].number.slice(0, 3) +
                          "/" +
                          bestCats[8].name
                        }
                      >
                        {bestCats[8].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>
                  Not sure if this is a Cat... There's just something about that
                  cool 'stache…
                  <p></p>
                  <b>Other forms: </b>Nobiluga, Nobilan Pasalan Brigade
                  <p></p>
                  <b>Pros: </b>High piercing range of 500 extends his effective
                  range, making him effective against enemies like{" "}
                  <Link to={"/enemyinfo/023/Dark%20Emperor%20Nyandam"}>
                    Dark Emperor Nyandam
                  </Link>{" "}
                  and{" "}
                  <Link to={"/enemyinfo/185/Professor%20A."}>Professor A.</Link>
                  . He can even attack the base if the boss has been pushed back
                  against it.
                  <p></p>
                  <b>Cons: </b>Its immunity to Warp and Knockback are a bane for
                  its survivability as it has no chance to run from the enemy
                  frontliners. He dies too easily and has a huge blindspot,
                  resulting in limited practical use for him.
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Mystican Pasalan"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  8.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[7].number +
                      ".png"
                    }
                    alt={bestCats[7].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[7].number.slice(0, 3) +
                          "/" +
                          bestCats[7].name
                        }
                      >
                        {bestCats[7].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>
                  Not sure if this is a Cat... or a Gal? There's just something
                  about that taste in swimwear…
                  <p></p>
                  <b>Other forms: </b>Summerluga, Bikinilan Pasalan
                  <p></p>
                  <b>Pros: </b>Its Surge attack works well against enemies with
                  many knockbacks, such as{" "}
                  <Link to={"/enemyinfo/040/Rain%20D."}>Rain D.</Link>
                  <p></p>
                  <b>Cons: </b>Inconsistent Surge spawn area means that the
                  Surge attacks may even form behind the enemies’ backline,
                  making it next to useless. Coupled with its poor DPS, the
                  stages where it proves actually useful are few and far
                  between.
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Fabulous Pasalan"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <InPageAdComponent
              style={{ marginTop: "8px" }}
              dataAdClient="ca-pub-1920730948516638"
              dataAdSlot="8579060881"
            />
            <div style={{ paddingTop: "1em" }} />
            {/* {this.state.viewportWidth > 1024 ? (
              <span>
                <VenatusAdWithPlaceholder
                  placementId={VENATUS_DESKTOP_LEADERBOARD}
                />
              </span>
            ) : (
              <VenatusAdWithPlaceholder
                placementId={VENATUS_MOBILE_INCONTENT}
              />
            )} */}
            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  7.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[6].number +
                      ".png"
                    }
                    alt={bestCats[6].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[6].number.slice(0, 3) +
                          "/" +
                          bestCats[6].name
                        }
                      >
                        {bestCats[6].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>Not sure if this is a Cat… Maybe if you
                  evolve him…
                  <p></p>
                  <b>Other forms: </b>Nekoluga, Unknown Cat
                  <p></p>
                  <b>Pros: </b>His range is his key strength, supplemented by
                  his improved abilities to Freeze and Knockback non-metal
                  enemies in True form with his area attack.
                  <p></p>
                  <b>Cons: </b>His poor attack rate stands at one of the highest
                  in the Lugas family. Coupled with his weak health and middling
                  damage, he’s also rather fragile and easily replaceable by
                  other backliners like{" "}
                  <Link to={"/catinfo/036/Cyberpunk%20Cat"}>Cyberpunk Cat</Link>{" "}
                  or{" "}
                  <Link to={"/catinfo/137/The%20Peach%20Devils"}>
                    The Peach Devils
                  </Link>{" "}
                  (especially against red enemies).
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Ultralan Pasalan"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row style={{ padding: "16px 0 0 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  6.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[5].number +
                      ".png"
                    }
                    alt={bestCats[5].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[5].number.slice(0, 3) +
                          "/" +
                          bestCats[5].name
                        }
                      >
                        {bestCats[5].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>Not sure if this is a Cat… There's just
                  something about that pandimensional crystal…
                  <p></p>
                  <b>Other forms: </b>Legeluga
                  <p></p>
                  <b>Pros: </b>It has an unusually short time between attacks
                  for the Nekoluga family, giving it a high DPS. With most wave
                  attackers having relatively short ranges, such as{" "}
                  <Link to={"/enemyinfo/178/Elizabeth%20the%20LVIth"}>
                    Elizabeth the LVIth
                  </Link>
                  , it can deal a huge amount of damage against them while
                  staying relatively safe behind the frontlines.
                  <p></p>
                  <b>Cons: </b>Probably one of the worst Legend Rare Cats, given
                  its middling range and long cooldown. Other rushers with a
                  similar performance such as{" "}
                  <Link to={"/catinfo/160/Divine%20Kalisa"}>Divine Kalisa</Link>{" "}
                  and{" "}
                  <Link to={"/catinfo/442/Valiant%20D'arktanyan"}>
                    Valiant D'arktanyan
                  </Link>{" "}
                  typically have a shorter cooldown of 90s or less. Its immunity
                  to Warp and Knockback also makes it more prone to taking
                  damage.
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Legelan Pasalan"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  5.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[4].number +
                      ".png"
                    }
                    alt={bestCats[4].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[4].number.slice(0, 3) +
                          "/" +
                          bestCats[4].name
                        }
                      >
                        {bestCats[4].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>
                  Not sure if this is a Cat… There's just something about that
                  neck…
                  <p></p>
                  <b>Other forms: </b>Kubiluga, Kubilan Pasalan
                  <p></p>
                  <b>Pros: </b>Evolved form has an interesting crowd control
                  ability - a Lv.8 Wave attack that also Knockbacks traited
                  enemies. In True form, his wave attack is combined instead
                  with a Critical hit ability that can clear up low-levelled
                  Metal peons. Also good for a Cat Combo with{" "}
                  <Link to={"/catinfo/005/Giraffe%20Cat"}>Giraffe Cat</Link>{" "}
                  that increases the Worker Cat’s starting level by 2, useful
                  for the Catclaw Dojo.
                  <p></p>
                  <b>Cons: </b>His evolved form is generally more useful than
                  his true form, due to an extremely low base damage.
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "E. Kubilan Pasalan"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <InPageAdComponent
              style={{ marginTop: "8px" }}
              dataAdClient="ca-pub-1920730948516638"
              dataAdSlot="8579060881"
            />
            <div style={{ paddingTop: "1em" }} />
            {/* {this.state.viewportWidth > 1024 ? (
              <span>
                <VenatusAdWithPlaceholder
                  placementId={VENATUS_DESKTOP_LEADERBOARD}
                />
              </span>
            ) : (
              <VenatusAdWithPlaceholder
                placementId={VENATUS_MOBILE_INCONTENT}
              />
            )} */}
            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  4.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[3].number +
                      ".png"
                    }
                    alt={bestCats[3].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[3].number.slice(0, 3) +
                          "/" +
                          bestCats[3].name
                        }
                      >
                        {bestCats[3].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>
                  Not sure if this is a Cat… There's just something about those
                  legs…
                  <p></p>
                  <b>Other forms: </b>Asiluga, Asilan Pasalan
                  <p></p>
                  <b>Pros: </b>
                  Undisputed top in the{" "}
                  <Link to={"/best-cats-for-range"}>
                    Best Cats for Range
                  </Link>{" "}
                  list. Extremely situational Uber that shines in stages such as{" "}
                  <Link to={"/stageinfo/700049/Floor%2050"}>Floor 50</Link> of
                  the Heavenly Tower against{" "}
                  <Link to={"/enemyinfo/516/Master%20Uril/100"}>
                    Master Uril
                  </Link>
                  , which has both Surge Attack and a decent range with its
                  Omnistrike ability, when you need just that extra bit of
                  control to maintain your defenses and win. Combine it with{" "}
                  <Link to={"/catinfo/004/Gross%20Cat"}>Gross Cat</Link> if you
                  can spare the extra slot for a Cat Combo that extends its Slow
                  duration.
                  <p></p>
                  <b>Cons: </b>Damage isn’t anything to speak of, plus the same
                  weaknesses as the others in the Nekoluga family. Ultra slow,
                  long respawn time, terrible health.
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Assassinlan Pasalan"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row style={{ padding: "16px 0 0 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  3.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[2].number +
                      ".png"
                    }
                    alt={bestCats[2].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[2].number.slice(0, 3) +
                          "/" +
                          bestCats[2].name
                        }
                      >
                        {bestCats[2].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>Not sure if this is a Cat… There's just
                  something about that belly…
                  <p></p>
                  <b>Other forms: </b>Balaluga, Balalan Pasalan
                  <p></p>
                  <b>Pros: </b>
                  Also on the{" "}
                  <Link to={"/best-cats-for-range"}>
                    Best Cats for Range
                  </Link>{" "}
                  list. Its area attack and control abilities, where it can
                  Weaken and Freeze enemies, makes it useful in attacking
                  long-ranged enemies like{" "}
                  <Link to={"/enemyinfo/185/Professor%20A."}>Professor A.</Link>
                  . It works well with other long distance cats like{" "}
                  <Link to={"/catinfo/036/Cyberpunk%20Cat"}>Cyberpunk Cat</Link>
                  .<p></p>
                  <b>Cons: </b>There’s nothing too special about it other than
                  its range, and is easily replaceable by other somewhat long
                  distance controllers or even rushers like{" "}
                  <Link to={"/catinfo/026/Awakened%20Bahamut%20Cat"}>
                    Awakened Bahamut
                  </Link>
                  , depending on the stage.
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Piccolan Pasalan"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  2.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[1].number +
                      ".png"
                    }
                    alt={bestCats[1].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[1].number.slice(0, 3) +
                          "/" +
                          bestCats[1].name
                        }
                      >
                        {bestCats[1].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>Not sure if this is a Cat… There's just
                  something about those… spikes???
                  <p></p>
                  <b>Other forms: </b>Togeluga, Togelan Pasalan
                  <p></p>
                  <b>Pros: </b>
                  Thanks to his Strengthen ability, his attack power triples at
                  99% health, making him effectively stronger than even{" "}
                  <Link to={"/catinfo/171/Lufalan%20Pasalan"}>
                    Lufalan Pasalan
                  </Link>
                  . Together with his area attack, these make him a decent
                  anti-wave cat. A high KB count also means any gaps in
                  meatshielding may be forgiven.
                  <p></p>
                  <b>Cons: </b>Only useful in his True form, when he gains
                  somewhat decent health.
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Shishilan Pasalan"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <InPageAdComponent
              style={{ marginTop: "8px" }}
              dataAdClient="ca-pub-1920730948516638"
              dataAdSlot="8579060881"
            />
            <div style={{ paddingTop: "1em" }} />
            {/* {this.state.viewportWidth > 1024 ? (
              <span>
                <VenatusAdWithPlaceholder
                  placementId={VENATUS_DESKTOP_LEADERBOARD}
                />
              </span>
            ) : (
              <VenatusAdWithPlaceholder
                placementId={VENATUS_MOBILE_INCONTENT}
              />
            )} */}
            <Row style={{ padding: "0px 0 0px 0" }}>
              <Row style={{ padding: "0px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  1.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[0].number +
                      ".png"
                    }
                    alt={bestCats[0].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[0].number.slice(0, 3) +
                          "/" +
                          bestCats[0].name
                        }
                      >
                        {bestCats[0].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>
                  Not sure if this is a Cat… There's just something about those
                  arms…
                  <p></p>
                  <b>Other forms: </b>Tecoluga, Tesalan Pasalan
                  <p></p>
                  <b>Pros: </b>
                  Also on the{" "}
                  <Link to={"/best-cats-for-attack"}>
                    Best Cats for Attack
                  </Link>{" "}
                  and{" "}
                  <Link to={"/best-cats-for-range"}>Best Cats for Range</Link>{" "}
                  list. He outranges even{" "}
                  <Link to={"/catinfo/260/Almighty%20Aphrodite"}>
                    Almighty Aphrodite
                  </Link>{" "}
                  . Despite being insanely slow, he’s a situational Uber that is
                  invaluable for some stages, such as{" "}
                  <Link to={"/stageinfo/700039/Floor%2040"}>Floor 40</Link> of
                  the Heavenly Tower and some stages with the{" "}
                  <Link to={"/enemyinfo/071/Metal%20Cyclone"}>
                    Metal Cyclone
                  </Link>{" "}
                  . Be prepared for a drawn out battle if you’re planning to use
                  him in any meaningful way, but he’ll do the trick as long as
                  you keep him well protected.
                  <p></p>
                  <b>Cons: </b>His single-target attack means he doesn’t perform
                  well in stages with many peons. With his long cooldown time,
                  meatshielding is vital for him - some stages don’t give you
                  the chance to recover once he’s gone. As with all the cats in
                  this family, don’t bother with his unevolved form.
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Lufalan Pasalan"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <InPageAdComponent
              style={{ marginTop: "8px" }}
              dataAdClient="ca-pub-1920730948516638"
              dataAdSlot="8579060881"
            />
            <div style={{ paddingTop: "1em" }} />
            {/* {this.state.viewportWidth > 1024 ? (
              <span>
                <VenatusAdWithPlaceholder
                  placementId={VENATUS_DESKTOP_LEADERBOARD}
                />
              </span>
            ) : (
              <VenatusAdWithPlaceholder
                placementId={VENATUS_MOBILE_INCONTENT}
              />
            )} */}
            <Row style={{ padding: "6px 0 6px 0", marginTop: "6px" }}>
              <Divider orientation="left" style={{ fontSize: "24px" }}>
                Tier List
              </Divider>
              <TierListTable
                selectedCats={tierList}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row style={{ padding: "6px 0 6px 0" }}>
              <Divider />
              <h3>Compare all 11 cats below</h3>
              <BestCatsTable
                selectedCats={bestCats}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row
              style={{
                padding: "24px 20px 18px 20px",
                backgroundColor: "#ffa50038",
                textAlign: "center",
                margin: "0 0 8px 0",
              }}
            >
              <div style={{ fontSize: "16px" }}>
                Want to compare the stats of any cat in The Battle Cats?
              </div>
              <Divider
                style={{ backgroundColor: "orange", marginTop: "12px" }}
              ></Divider>
              <Button href="/comparecats" size="large">
                Compare more cats
              </Button>
            </Row>
          </Content>
        </Layout>
        <HorizontalAdPopup
          dataAdClient="ca-pub-1920730948516638"
          dataAdSlot="3694383950"
        ></HorizontalAdPopup>
        {/* <div id="waldo-tag-14678"></div> */}
        {/* {this.state.viewportWidth > 1024 ? (
          <div>
            <VenatusAd
              placementId={VENATUS_RICH_MEDIA_WITH_STICKY_VERTICAL}
              style={{ display: "none" }}
            />
          </div>
        ) : (
          <div>
            <VenatusAd
              placementId={VENATUS_RICH_MEDIA}
              style={{ display: "none" }}
            />
          </div>
        )} */}
      </div>
    );
  }
}

export default Lugas;

Lugas.propTypes = {
  applyViewportChange: PropTypes.number,
};

Lugas.defaultProps = {
  applyViewportChange: 250,
};



// WEBPACK FOOTER //
// ./src/components/content/tierlist/Lugas.js